import { useState } from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';

import { AppRoutes } from './app/routes';
import { createQueryClient } from './app/queryClient';

export function App() {
  // Um cliente por montagem da aplicacao. Criar no corpo do componente sem
  // `useState` produziria um cache novo a cada renderizacao.
  const [queryClient] = useState(createQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </QueryClientProvider>
  );
}
